<!-- 由 suu 创建于 2025-11-14 星期五 -->
<template>
  <div class="course-plan-show" v-if="over">
    <div class="cps-noplan-title">训练计划还未生成</div>
    <div class="cps-noplan-sub">系统已提醒教练尽快为您制定训练计划</div>
    <img
      class="cps-noplan-img"
      src="https://cdnvue.gymcity.com.cn/uploads/scan-w-bg-wait"
      alt=""
    />
    <div class="cps-noplan-btn user-btn" @click="goToOutline">查看训练大纲</div>
  </div>
  <vLoading v-else />
</template>

<script>
export default {
  name: 'course-plan-show',

  components: {},

  props: {},

  data() {
    return {
      courseid: this.$route.query.courseid || '', // 传入的课程courseid
      pid: this.$route.query.pid || '', // 传入的pid
      uid: this.$route.query.uid || '', // 传入的uid
      over: false // 是否加载完成
    }
  },

  computed: {},

  watch: {},

  created() {
    if (this.pid) {
      this.$router.replace(`/newplanshow?pid=${this.pid}&showOutlineBtn=1`)
    } else if (this.courseid) {
      this.getCoursePid()
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 获取课程pid
    async getCoursePid() {
      const res = await this.$http.get(
        'member/AppEntrance?a=getAppointPreferenceFrame',
        {
          courseid: this.courseid
        }
      )
      if (res.data.code === 200 && res.data.data) {
        this.pid = res.data.data.pid
        if (this.pid) {
          this.$router.replace(`/newplanshow?pid=${this.pid}`)
        }
      }
      this.over = true
    },
    goToOutline() {
      this.$router.push(`/newoutline?uid=${this.uid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.course-plan-show {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  text-align: left;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(90);
  padding-bottom: calc(#{vw(90)} + constant(safe-area-inset-bottom));
  padding-bottom: calc(#{vw(90)} + env(safe-area-inset-bottom));
  .cps-noplan-title {
    font-size: vw(20);
    margin-top: 20%;
    font-weight: 500;
    color: #000000;
  }
  .cps-noplan-sub {
    font-size: vw(14);
    color: #000000;
    line-height: vw(28);
    margin-top: vw(1);
  }
  .cps-noplan-img {
    width: vw(200);
    margin-top: vw(22);
  }
  .cps-noplan-btn {
    width: vw(300);
    height: vw(48);
    box-sizing: border-box;
    background-color: #ff2270;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: vw(99);
    color: #fff;
    font-size: vw(16);
    font-weight: 500;
    position: fixed;
    bottom: vw(10);
    bottom: calc(#{vw(10)} + constant(safe-area-inset-bottom));
    bottom: calc(#{vw(10)} + env(safe-area-inset-bottom));
    z-index: 9;
  }
}
</style>
